import { styled } from '@pulse-web-ui/theme';

export const FiltersArrayList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
